module.exports = __webpack_public_path__ + "assets/img/GlobeTrekker_cover.4a571db0-ps.jpg";